<template>
  <div id="app">
    <div class="app-top" v-if="path !== '/miniLogin'">
      <Head />
      <h4 class="inro">打造新一代产业互联网</h4>
      <router-view />
    </div>
    <Foot v-if="path !== '/miniLogin'" />
    <router-view v-if="path === '/miniLogin'" />
    <div class="virtual-btns" v-if="showVirtualBtn">
      <Button
        class="virtual-btns-item"
        type="danger"
        :onClick="handleLogout"
        text="退出登录"
      />
    </div>
  </div>
</template>

<script>
import Head from '@/components/Head/index.vue';
import Foot from '@/components/Foot/index.vue';
import Button from '@/components/Button';

import env from '@/utils/env';
import { logout } from '@/utils';
import { routes, debug, useTestApi } from '@/config';

export default {
  name: 'App',
  data() {
    return {
      isProd: env.isProd(),
    };
  },
  mounted() {
    // console.log(this.path)
    this.fetchWebInfo();
    window.addEventListener('beforeunload', () => {
      localStorage.removeItem('WEB_INFO');
    });
  },
  methods: {
    handleLogout() {
      logout();
      this.$router.replace({
        path: routes.login,
        query: this.$route.query,
        params: this.$route.params,
      });
    },
    fetchWebInfo() {
      // 获取可配置信息
      let siteUrl = 'zlgx.com';
      let hsot = 'news.zlgx.com';
      if (
        ['local.test.zlgx.com', 'sso.test.zlgx.com'].includes(document.domain)
      ) {
        siteUrl = 'test.zlgx.com';
        hsot = 'news.test.zlgx.com';
      }

      let params = {
        platformCode: 'common',
        platformType: 'front',
        siteUrl,
      };

      fetch(`//${hsot}/api/v1/cms/site/info`, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.text())
        .then((res) => {
          let data = JSON.parse(res);
          if (data.code === 0) {
            localStorage.setItem('WEB_INFO', JSON.stringify(data.data));
            const changeFavicon = (link) => {
              let el = document.createElement('link');
              el.rel = 'icon';
              el.href = link;
              document.head.appendChild(el);
            };
            changeFavicon(data.data.logo); // 动态修改标签栏图标
          }
        })
        .catch((err) => console.log(err));
    },
  },
  components: { Head, Foot, Button },
  computed: {
    path() {
      return this.$route.path;
    },
    showVirtualBtn() {
      return (
        this.path !== routes.miniLogin &&
        this.path !== routes.login &&
        this.path !== routes.register &&
        !this.isProd
      );
    },
  },
};
</script>
<style scoped>
.virtual-btns {
  position: fixed;
  top: 100px;
  right: 100px;
  z-index: 10;
}
.virtual-btns-item {
  padding: 0 10px;
}
</style>
<style>
* {
  padding: 0;
  margin: 0;
}
body > div input.hidden[class] {
  /* display: none; */
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  outline: none !important;
  display: block !important;
  height: 0 !important;
  overflow: hidden !important;
  visibility: hidden !important;
  transition: none !important;
}
html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
  /*background: #ffffff;*/
}
.form-item-select {
  font-size: 14px;
}
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
#app {
  height: 100%;
  font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
  color: #ffffff;

  overflow-x: hidden;
}
.app-top {
  background-image: url('./assets/bg_main.png');
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  padding: 0 0 50px 0;
}
.inro {
  text-align: center;
  margin: 0;
  padding: 30px 0 50px 0;
  letter-spacing: 3px;
}
::-ms-clear,
::-ms-reveal {
  display: none;
}
input::-webkit-input-safebox-button {
  display: none;
}
</style>
